import React from 'react';
import Link from '../../../../../theme/components/Link';
import { StyledMenuItemPrimary } from '../AvatarMenu';
import { getPolyglot } from '../../../../../i18n';

export const AppMenuLinks = (props: {
  listApps: string[];
  handleClose: () => void;
}) => {
  const { listApps, handleClose } = props;
  const polyglot = getPolyglot();

  return listApps.map((stringApp: string) => (
    <Link to={`/${stringApp}`} onClick={handleClose} key={stringApp}>
      <StyledMenuItemPrimary>
        {polyglot.t(`nav.menu.${stringApp}`)}
      </StyledMenuItemPrimary>
    </Link>
  ));
};
